import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { EnvironmentService } from '../../utility/environment.service';

@Component({
  selector: 'app-error-handler',
  templateUrl: './error-handler.component.html',
  styleUrls: ['./error-handler.component.css'],
})
export class ErrorHandlerComponent implements OnInit {
  @Input() error: string = '';
  constructor(
    private route: ActivatedRoute,
    private keycloak: KeycloakService,
    private environmentser: EnvironmentService,
     ) {}

  ngOnInit(): void {}

  
  logout() {
    this.clearCookie('current_user');
    this.clearCookie('current_approle');
    this.keycloak.logout(this.environmentser.getLandingURL());
    }

    private clearCookie(name: string) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
}
